import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Container,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Snackbar,
  Typography,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { location, locationGeo } from "../Utils/Const";

import DashboardHeader from "../Dashboard/DashboardHeader";
import AmountCard from "./AmountCard";
import BeneficiariesCard from "./BeneficiariesCard";
import WhyWalletTransfer from "./WhyWalletTransfer";
import RecentTransfers from "./RecentTransfers";
import { ApplicationType, entity_id, Platform } from "../Utils/Const";
import { baseapi } from "../Environmentalurl";
import { useNavigate } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function TransferToWallet() {
  const [amount, setAmount] = useState("");
  const [toMobile, setToMobile] = useState("");
  const [tpin, setTpin] = useState("");
  const [openTpin, setOpenTpin] = useState(false);
const ip = useIPAddress();
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [recentTransfers, setRecentTransfers] = useState([]);

  const navigate = useNavigate();

  // ===== TOAST STATE =====
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showToast = (message, severity = "warning") => {
    setToast({ open: true, message, severity });
  };

  const isValidAmount =
    amount.trim() !== "" && Number(amount) > 0 && toMobile.length === 10;

  // ================= RECENT TRANSFERS =================
  const callRecentFundTransferAPI = async () => {
    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_Recent_FundtransferList",
      Mobilenumber: sessionStorage.getItem("mobileNumber"),
      Platform,
      ApplicationType,
      GeoLocation: locationGeo,
      MachineID: ip,
      EntityID: entity_id,
      SessionID: sessionStorage.getItem("SessionID"),
    };

    try {
      const res = await api.post(
        `${baseapi}/JanAadhaareWalletRecentFundtransferList`,
        payload,
      );

      if (res.data?.Response_Code === "1000") {
        setBeneficiaries(res.data.Info || []);
        setRecentTransfers(res.data.Info || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    callRecentFundTransferAPI();
  }, []);

  const checkKycStatus = async () => {
    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_GetKYCStatus",
      SSO_ID: "-",
      Mobilenumber: toMobile,
      MachineID: ip,
      Platform,
      ApplicationType,
      GeoLocation: locationGeo,
      EntityID: entity_id,
      SessionID: sessionStorage.getItem("SessionID"),
    };

    try {
      const res = await api.post(
        `${baseapi}/JanaadhaareWalletGetKYCStatus`,
        payload,
      );

      if (res.data?.Response_Code === "4000") {
        if (res.data.KYC === "Full KYC") {
          setOpenTpin(true);
        } else if (res.data.KYC === "Low KYC") {
          showToast("Low KYC user. Transaction not allowed.", "warning");
        } else {
          showToast(res.data.Message || "KYC status unavailable", "warning");
        }
      } else {
        showToast(res.data?.Message || "Customer details not found", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("KYC verification failed", "error");
    }
  };

  const handleProceed = () => {
    checkKycStatus();
  };
  const handleFundTransfer = async () => {
    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_FundTransfer",
      Mobilenumber: sessionStorage.getItem("mobileNumber"),
      ToMobilenumber: toMobile,
      SessionID: sessionStorage.getItem("SessionID"),
      TrxnAmount: Number(amount).toFixed(2),
      ServiceID: "4",
      Narration: `Wallet to Wallet transfer Amount of Rs. ${amount} to ${toMobile}`,
      TPIN: tpin,
      OrderId: Date.now().toString(),
      MachineID: ip,
      Platform,
      ApplicationType,
      GeoLocation: locationGeo,
      EntityID: entity_id,
    };

    try {
      const res = await api.post(
        `${baseapi}/JanAadhaareWalletFundTransfer`,
        payload,
      );

      if (res.data?.Response_Code === "1800") {
        showToast("Fund Transfer Successful", "success");
        setAmount("");
        setToMobile("");
        setTpin("");
        setOpenTpin(false);
        callRecentFundTransferAPI();
        setTimeout(() => {
          navigate("/dashboard");
        }, 500);
      } else {
        showToast(res.data?.Message || "Transaction Failed", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Transaction Failed", "error");
    }
  };

  return (
    <>
      <DashboardHeader />

      <Box sx={{ bgcolor: "#f5f7fb", minHeight: "100vh", py: 4 }}>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 7 }} item xs={12} md={7}>
              <AmountCard
                amount={amount}
                setAmount={setAmount}
                toMobile={toMobile}
                setToMobile={setToMobile}
                isValidAmount={isValidAmount}
                onProceed={handleProceed}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 5 }} item xs={12} md={5}>
              <BeneficiariesCard
                beneficiaries={beneficiaries}
                onSend={(mobile) => setToMobile(mobile)}
              />
              <WhyWalletTransfer />
            </Grid>
          </Grid>

          {/* <RecentTransfers recentTransfers={recentTransfers} /> */}
        </Container>
      </Box>

      {/* ===== TPIN DIALOG ===== */}
      <Dialog
        open={openTpin}
        onClose={() => setOpenTpin(false)}
        BackdropProps={{
          sx: {
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0,0,0,0.3)",
          },
          
        }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            width: 360,
            p: 1,
          },
        }}
      >
        {/* TITLE */}
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: 18,
            pb: 0,
          }}
        >
          Secure Verification
        </DialogTitle>

        <Typography
          sx={{
            textAlign: "center",
            fontSize: 13,
            color: "text.secondary",
            mb: 2,
          }}
        >
          Enter your 4-digit TPIN to proceed
        </Typography>

        {/* CONTENT */}
        <DialogContent>
          <TextField
            fullWidth
            autoFocus
            type="password"
            value={tpin}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value)) {
                setTpin(e.target.value);
              }
            }}
            inputProps={{
              maxLength: 4,
              inputMode: "numeric",
              style: {
                textAlign: "center",
                letterSpacing: "8px",
                fontSize: "22px",
                fontWeight: 600,
              },
            }}
            placeholder="● ● ● ●"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                height: 56,
              },
            }}
          />

          {/* ACTION BUTTONS */}
          <Box mt={3} display="flex" gap={2}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => {
                setTpin("");
                setOpenTpin(false);
              }}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 500,
              }}
            >
              Cancel
            </Button>

            <Button
              fullWidth
              variant="contained"
              disabled={tpin.length !== 4}
              onClick={handleFundTransfer}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                color: "white",
              }}
            >
              Confirm
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* ===== TOAST MESSAGE ===== */}
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={toast.severity}
          onClose={() => setToast({ ...toast, open: false })}
        >
          {toast.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
